export class ValidationMessagesHelper {
    public static readonly RECORDING_LIST_FETCH_FAILURE = 'Unable to get recordings list';
    public static readonly RECORDING_CREATE_FAILURE = 'Unable to create recording';
    public static readonly RECORDING_UPDATE_FAILURE = 'Unable to update recording';
    public static readonly RECORDING_DELETE_FAILURE = 'Unable to delete recording';
    public static readonly RECORDING_DELETE_SUCCESS = 'Recording has been deleted successfully';
    public static readonly RECORDING_REMOVED_CREATING_NEW = 'Recording has been removed. Create a new recording.';
    public static readonly RECORDING_SCENARIO_CONFIRM = 'This recording is associated with a scenario. Do you want to proceed?';
    public static readonly RECORDING_UPDATE_SUCCESS = 'Recording has been updated successfully';
    public static readonly RECORDING_CREATED_SUCCESS = 'Recording has been created successfully';
    public static readonly NO_ELEMENT_TO_VERIFY = 'No element available to verify. Perform an action first.';
    public static readonly VERIFY_STEP_ADDED = 'Verify step added';
    public static readonly ASSERT_STEP_ADDED = 'Assert step added';
    public static readonly ENTER_RUN_NAME = 'Please enter a Run Name';
    public static readonly ENTER_URL = 'Please enter a URL';
    public static readonly RECORDING_STARTED = 'Recording started:';
    public static readonly FAILED_START_RECORDING = 'Failed to start recording:';
    public static readonly CLEARED_RUN = 'Cleared current run. You can now Start Recording.';
    public static readonly FAILED_CLEAR = 'Failed to clear:';
    public static readonly RECORDING_COMPLETED = 'Recording completed:';
    public static readonly STEPS_CAPTURED = 'steps captured';
    public static readonly FAILED_STOP_RECORDING = 'Failed to stop recording:';
    public static readonly RECORDING_RESUMED = 'Recording resumed';
    public static readonly RECORDING_PAUSED = 'Recording paused';
    public static readonly FAILED_PAUSE_RESUME = 'Failed to pause/resume:';
    public static readonly NO_SESSION_FOUND = 'No recording session found';
    public static readonly RECORDING_SAVED = 'Recording saved successfully';
    public static readonly RECORDING_UPDATED = 'Recording updated successfully';
    public static readonly RECORDING_CLONED = 'Recording cloned successfully';
    public static readonly FAILED_SAVE_RECORDING = 'Failed to save recording';
    public static readonly FAILED_SAVE_RECORDING_WITH_ERROR = 'Failed to save recording:';
    public static readonly NO_STEPS_TO_EXECUTE = 'No steps to execute';
    public static readonly STARTING_EXECUTION = 'Starting execution of';
    public static readonly STEPS_TEXT = 'steps...';
    public static readonly EXECUTION_STOPPED_BY_USER = 'Execution stopped by user';
    public static readonly STEP_VERIFICATION_FAILED = '⚠️ Step';
    public static readonly VERIFICATION_FAILED = 'verification failed:';
    public static readonly STEP_FAILED = '❌ Step';
    public static readonly FAILED = 'failed:';
    public static readonly VERIFICATION_ERROR = 'verification error:';
    public static readonly THREW_ERROR = 'threw error:';
    public static readonly ALL_STEPS_SUCCESS = '✅ All';
    public static readonly STEPS_EXECUTED_SUCCESSFULLY = 'steps executed successfully!';
    public static readonly EXECUTION_COMPLETED = '⚠️ Execution completed:';
    public static readonly PASSED = 'passed,';
    public static readonly FAILED_TEXT = 'failed';
    public static readonly EXECUTION_FAILED = '❌ Execution failed:';
    public static readonly STEPS_FAILED = 'steps failed';
    public static readonly STOP_REQUESTED = 'Stop requested – finishing current step...';
    public static readonly ENTER_VALID_NUMBER = 'Please enter a valid non-negative number';
    public static readonly WAIT_STEP_ADDED = 'Wait step added';
    public static readonly MS_TEXT = 'ms';
    public static readonly STEP_DELETED = 'Step deleted';
    public static readonly OPTION_TO_SELECT_UPDATED = 'Option to select updated';
    public static readonly TARGET_TEXT_UPDATED = 'Target text updated';
    public static readonly STEP_VALUE_UPDATED = 'Step value updated';
    public static readonly INVALID_OPERATOR = 'Invalid operator';
    public static readonly STEP_OPERATOR_UPDATED = 'Step operator updated';
    public static readonly STEP_COPIED = 'Step copied';
    public static readonly INSERT_RECORD_PROMPT = 'Insert record: perform the action now to add a step after #';
    public static readonly NEW_STEP_INSERTED = 'New step inserted. Click + again to insert another.';
    public static readonly TARGET_TEXT_UPDATED_DROPDOWN = 'Target text updated (dropdown field). To change selected option, edit the value.';
    public static readonly WAIT_ADDED_BEFORE_STEP = 'Wait';
    public static readonly MS_ADDED_BEFORE_STEP = 'ms added before step #';
    public static readonly STEP_EXECUTED_SUCCESSFULLY = 'Step executed successfully';
    public static readonly STEP_FAILED_TEXT = 'Step failed:';
    public static readonly STEP_EXECUTION_ERROR = 'Step execution error:';
    public static readonly UNKNOWN_ERROR = 'Unknown error';
    public static readonly RECORDING_CANCELLED = 'Recording cancelled';
    public static readonly VIEW_RECORDING = 'View recording:';
    public static readonly FAILED_LOAD_RECORDINGS = 'Failed to load recordings';
    public static readonly ENTER_PAGE_TEXT_TO_VERIFY = 'Please enter text to verify on the page';
    public static readonly ENTER_LABEL_TO_VERIFY = 'Please enter the label to verify';
    public static readonly ENTER_EXPECTED_VALUE = 'Please enter the expected value';
    public static readonly PAGE_TEXT_STEP_ADDED = 'page text step added';
    public static readonly LABEL_VALUE_STEP_ADDED = 'label+value step added';
    
    public static getVerifyStepAdded(isAssert: boolean): string {
        return isAssert ? this.ASSERT_STEP_ADDED : this.VERIFY_STEP_ADDED;
    }
    
    public static getRecordingStarted(runName: string): string {
        return `${this.RECORDING_STARTED} ${runName}`;
    }
    
    public static getFailedStartRecording(errorMessage: string): string {
        return `${this.FAILED_START_RECORDING} ${errorMessage}`;
    }
    
    public static getFailedClear(errorMessage: string): string {
        return `${this.FAILED_CLEAR} ${errorMessage}`;
    }
    
    public static getRecordingCompleted(totalSteps: number): string {
        return `${this.RECORDING_COMPLETED} ${totalSteps} ${this.STEPS_CAPTURED}`;
    }
    
    public static getFailedStopRecording(errorMessage: string): string {
        return `${this.FAILED_STOP_RECORDING} ${errorMessage}`;
    }
    
    public static getFailedPauseResume(errorMessage: string): string {
        return `${this.FAILED_PAUSE_RESUME} ${errorMessage}`;
    }
    
    public static getFailedSaveRecording(errorMessage: string): string {
        return `${this.FAILED_SAVE_RECORDING_WITH_ERROR} ${errorMessage}`;
    }
    
    public static getStartingExecution(stepCount: number): string {
        return `${this.STARTING_EXECUTION} ${stepCount} ${this.STEPS_TEXT}`;
    }
    
    public static getStepVerificationFailed(stepIndex: number, errorMsg: string): string {
        return `${this.STEP_VERIFICATION_FAILED} ${stepIndex + 1} ${this.VERIFICATION_FAILED} ${errorMsg}`;
    }
    
    public static getStepFailed(stepIndex: number, errorMsg: string): string {
        return `${this.STEP_FAILED} ${stepIndex + 1} ${this.FAILED} ${errorMsg}`;
    }
    
    public static getStepVerificationError(stepIndex: number, errorMsg: string): string {
        return `${this.STEP_VERIFICATION_FAILED} ${stepIndex + 1} ${this.VERIFICATION_ERROR} ${errorMsg}`;
    }
    
    public static getStepThrewError(stepIndex: number, errorMsg: string): string {
        return `${this.STEP_FAILED} ${stepIndex + 1} ${this.THREW_ERROR} ${errorMsg}`;
    }
    
    public static getAllStepsSuccess(successCount: number): string {
        return `${this.ALL_STEPS_SUCCESS} ${successCount} ${this.STEPS_EXECUTED_SUCCESSFULLY}`;
    }
    
    public static getExecutionCompleted(successCount: number, failCount: number): string {
        return `${this.EXECUTION_COMPLETED} ${successCount} ${this.PASSED} ${failCount} ${this.FAILED_TEXT}`;
    }
    
    public static getExecutionFailed(failCount: number): string {
        return `${this.EXECUTION_FAILED} ${failCount} ${this.STEPS_FAILED}`;
    }
    
    public static getWaitStepAdded(ms: number): string {
        return `${this.WAIT_STEP_ADDED} (${Math.floor(ms)} ${this.MS_TEXT})`;
    }
    
    public static getInsertRecordPrompt(index: number): string {
        return `${this.INSERT_RECORD_PROMPT}${index + 1}`;
    }
    
    public static getWaitAddedBeforeStep(ms: number, index: number): string {
        return `${this.WAIT_ADDED_BEFORE_STEP} ${ms} ${this.MS_ADDED_BEFORE_STEP}${index + 1}`;
    }
    
    public static getStepFailedWithError(errorMsg: string): string {
        return `${this.STEP_FAILED_TEXT} ${errorMsg}`;
    }
    
    public static getStepExecutionError(errorMsg: string): string {
        return `${this.STEP_EXECUTION_ERROR} ${errorMsg || this.UNKNOWN_ERROR}`;
    }
    
    public static getViewRecording(runName: string): string {
        return `${this.VIEW_RECORDING} ${runName}`;
    }
    
    public static getPageTextVerificationAdded(assert: boolean): string {
        return `${assert ? 'Assert' : 'Verify'} ${this.PAGE_TEXT_STEP_ADDED}`;
    }
    
    public static getLabelValueVerificationAdded(assert: boolean): string {
        return `${assert ? 'Assert' : 'Verify'} ${this.LABEL_VALUE_STEP_ADDED}`;
    }
}